import { useMutation, useQueryClient } from "react-query";

import axios from "axios";

import { PAD_SCENARIO_SERVICE_ADDRESS } from "../../../constants/app.constants";
import { GetScenarioListKey } from "./useScenarioList";

const useDeleteScenario = () => {
  const client = useQueryClient();
  return useMutation(
    async (id: { $oid: string }) => {
      const response = await axios.delete<string>(
        `${PAD_SCENARIO_SERVICE_ADDRESS}/api/v1/pad-scenario/${id.$oid}`
      );
      return response.data;
    },
    {
      onSuccess: async () => {
        await client.invalidateQueries(GetScenarioListKey);
      }
    }
  );
};

export default useDeleteScenario;
